import React, {useEffect} from "react";
import Navbar from '../navbar/Navbar'
import './Servizi.css'
import Footer from "../footer/Footer";
import Servizi_options from "./Servizi_options";

export default function Servizi(props) {

    useEffect(() => {
        document.title = 'Servizi'
    }, [])

    return (
        <React.Fragment>
            <Navbar data={props.data} setLanguage={props.setLanguage} getLanguage={props.getLanguage} button={1}/>
            <div id='MainDiv'>
                <h1 id={'title_recensioni'}>{props.data.services.title}</h1>
                <Servizi_options data={props.data}/>
            </div>
            <Footer data={props.data}/>

        </React.Fragment>
    )
}
